import { render, staticRenderFns } from "./SSplitButton.vue?vue&type=template&id=3fdb3aed&scoped=true&lang=pug"
import script from "./SSplitButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./SSplitButton.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./SSplitButton.vue?vue&type=style&index=0&id=3fdb3aed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fdb3aed",
  null
  
)

export default component.exports